export default __webpack_public_path__ + "static/media/vase.5e0cfa59.jpg";